import { generate } from '../../../core/js/utils/componentUtils';

export function attachEvents(store) {
    const quickshopClass = '.js-product-tile-control-quickshop';
    const dyApi = _.get(window, 'DY.API');

    if (dyApi) {

        const rrPlacement = this.parent.rrPlacement;

        $(document).on(
            this.scopedEvent('touchend click'),
            this.scopedSelector(quickshopClass),
            (e) => {
                // eslint-disable-next-line babel/new-cap
                dyApi('event', { name: `${rrPlacement} recs click - overall` });
                // eslint-disable-next-line babel/new-cap
                dyApi('event', { name: `${rrPlacement} recs click - quickshop` });
            }
        );

        $(document).on(
            this.scopedEvent('touchend click'),
            this.scopedSelector(`.js-product-tile:not(${quickshopClass})`),
            (e) => {
                // eslint-disable-next-line babel/new-cap
                dyApi('event', { name: `${rrPlacement} recs click - overall` });
                // eslint-disable-next-line babel/new-cap
                dyApi('event', { name: `${rrPlacement} recs click - Redirect` });
            }
        );

    }
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.js-dy-recommendations',
        attachEvents: attachEvents,
        name: 'dynamicYieldRecommendationComponent'
    };

    return generate(config, store, overrides);
}
